// @flow

import { apiCommand } from "./index.jsx"

export const ADD_JOBS = "ADD_JOBS"
export const JOB_ADD = "JOB_ADD"
export const JOB_UPDATE = "JOB_UPDATE"
export const JOB_LOG_UPDATE = "JOB_LOG_UPDATE"
export const JOB_PROGRESS_UPDATE = "JOB_PROGRESS_UPDATE"

export const addJobsAction = ( jobs: any ) => ( { type: ADD_JOBS, jobs } )

export const jobLogUpdate = ( jobId: number, log: string ) =>
  ( dispatch: any ) => dispatch( { type: JOB_LOG_UPDATE, jobId, log } )

export const jobProgressUpdate = ( jobId: number, progress: number ) =>
  ( dispatch: any ) => dispatch( { type: JOB_PROGRESS_UPDATE, jobId, progress } )

export const jobAdd = ( job: any ) => ( dispatch: any ) =>
  dispatch( { type: JOB_ADD, job } )

export const jobUpdate = ( job: any ) => ( dispatch: any ) =>
  dispatch( { type: JOB_UPDATE, jobId: job.id, job } )


export const getJobs = ( limit?: number ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getJobs", {
    limit,
  } )
    .then( resObj => resObj && dispatch( addJobsAction( resObj.result ) ) )

export const scheduleJob = ( type: string, jobData: any ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "scheduleJob", {
    type,
    data: jobData,
  } ).then( resObj => {
    if ( resObj.result.message ) {
      return resObj.result
    }
    return resObj && dispatch( addJobsAction( [ resObj.result.dbJob ] ) )
  } )



// WEBPACK FOOTER //
// ./src/actions/jobs.jsx